import * as commonConsts from '../pages/common/CommonConsts';

const getDocuments = (documents) => {
  return documents.map((x) => {
    return {
      ...x,
      id: x.id.toString(),
      attachmentId: Number(x.id),
      attachmentType: x.attachmentType,
      description: x.name
    };
  });
};

const getDocumentsByType = (documents, organisationType, documentUploadType) => {
  let result = [];

  if (organisationType === commonConsts.ORG_TYPE_Unincorporated) {
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules) {
      result = documents.filter(
        (x) =>
          x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules &&
          x.organisationType === commonConsts.ORG_TYPE_Unincorporated
      );
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects) {
      result = documents.filter(
        (x) =>
          x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects &&
          x.organisationType === commonConsts.ORG_TYPE_Unincorporated
      );
    }
  }

  if (organisationType === commonConsts.ORG_TYPE_IncorporatedAssociationNSW) {
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_CertificateIncorporation) {
      result = documents.filter(
        (x) =>
          x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_CertificateIncorporation &&
          x.organisationType === commonConsts.ORG_TYPE_IncorporatedAssociationNSW
      );
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects) {
      result = documents.filter(
        (x) =>
          x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects &&
          x.organisationType === commonConsts.ORG_TYPE_IncorporatedAssociationNSW
      );
    }
  }

  if (organisationType === commonConsts.ORG_TYPE_CompanyLimitedGuarantee) {
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_CertificateRegistration) {
      result = documents.filter(
        (x) =>
          x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_CertificateRegistration &&
          x.organisationType === commonConsts.ORG_TYPE_CompanyLimitedGuarantee
      );
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects) {
      result = documents.filter(
        (x) =>
          x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects &&
          x.organisationType === commonConsts.ORG_TYPE_CompanyLimitedGuarantee
      );
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules) {
      result = documents.filter(
        (x) =>
          x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules &&
          x.organisationType === commonConsts.ORG_TYPE_CompanyLimitedGuarantee
      );
    }
  }

  if (organisationType === commonConsts.ORG_TYPE_CompanyLtdShares) {
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_CertificateRegistration) {
      result = documents.filter(
        (x) =>
          x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_CertificateRegistration &&
          x.organisationType === commonConsts.ORG_TYPE_CompanyLtdShares
      );
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects) {
      result = documents.filter(
        (x) =>
          x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects &&
          x.organisationType === commonConsts.ORG_TYPE_CompanyLtdShares
      );
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules) {
      result = documents.filter(
        (x) =>
          x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules &&
          x.organisationType === commonConsts.ORG_TYPE_CompanyLtdShares
      );
    }
  }

  if (organisationType === commonConsts.ORG_TYPE_Other) {
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_Certificate) {
      result = documents.filter(
        (x) =>
          x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_Certificate &&
          x.organisationType === commonConsts.ORG_TYPE_Other
      );
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects) {
      result = documents.filter(
        (x) =>
          x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects &&
          x.organisationType === commonConsts.ORG_TYPE_Other
      );
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules) {
      result = documents.filter(
        (x) =>
          x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules &&
          x.organisationType === commonConsts.ORG_TYPE_Other
      );
    }
  }

  if (organisationType === commonConsts.ORG_TYPE_TrustDeed) {
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_TrustDeed) {
      result = documents.filter(
        (x) =>
          x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_TrustDeed &&
          x.organisationType === commonConsts.ORG_TYPE_TrustDeed
      );
    }
    if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects) {
      result = documents.filter(
        (x) =>
          x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_StatementObjects &&
          x.organisationType === commonConsts.ORG_TYPE_TrustDeed
      );
    }
  }

  return result;
};

const getDocumentsByDocumentUploadType = (documents, documentUploadType) => {
  let result = [];

  if (documentUploadType === commonConsts.DOC_UPLOAD_TYPE_CertificateNameChange) {
    result = documents.filter((x) => x.documentUploadType === commonConsts.DOC_UPLOAD_TYPE_CertificateNameChange);
  }

  return result;
};

const getAllDocuments = (supportingDocument, organisationType) => {
  const { documents } = supportingDocument;

  let allDocuments = [];

  if (organisationType === commonConsts.ORG_TYPE_Unincorporated) {
    const unincorporateConstitutionDocuments = getDocumentsByType(
      documents,
      commonConsts.ORG_TYPE_Unincorporated,
      commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules
    );
    allDocuments = allDocuments.concat(getDocuments(unincorporateConstitutionDocuments));

    const unincorporateStatementObjectDocuments = getDocumentsByType(
      documents,
      commonConsts.ORG_TYPE_Unincorporated,
      commonConsts.DOC_UPLOAD_TYPE_StatementObjects
    );
    allDocuments = allDocuments.concat(getDocuments(unincorporateStatementObjectDocuments));
  }

  if (organisationType === commonConsts.ORG_TYPE_IncorporatedAssociationNSW) {
    const incorporateCertificateIncDocuments = getDocumentsByType(
      documents,
      commonConsts.ORG_TYPE_IncorporatedAssociationNSW,
      commonConsts.DOC_UPLOAD_TYPE_CertificateIncorporation
    );
    allDocuments = allDocuments.concat(getDocuments(incorporateCertificateIncDocuments));

    const incorporateStatementObjectDocuments = getDocumentsByType(
      documents,
      commonConsts.ORG_TYPE_IncorporatedAssociationNSW,
      commonConsts.DOC_UPLOAD_TYPE_StatementObjects
    );
    allDocuments = allDocuments.concat(getDocuments(incorporateStatementObjectDocuments));
  }

  if (organisationType === commonConsts.ORG_TYPE_CompanyLimitedGuarantee) {
    const companyGuaranteeCertRegDocuments = getDocumentsByType(
      documents,
      commonConsts.ORG_TYPE_CompanyLimitedGuarantee,
      commonConsts.DOC_UPLOAD_TYPE_CertificateRegistration
    );
    allDocuments = allDocuments.concat(getDocuments(companyGuaranteeCertRegDocuments));

    const companyGuaranteeStatementObjDocuments = getDocumentsByType(
      documents,
      commonConsts.ORG_TYPE_CompanyLimitedGuarantee,
      commonConsts.DOC_UPLOAD_TYPE_StatementObjects
    );
    allDocuments = allDocuments.concat(getDocuments(companyGuaranteeStatementObjDocuments));

    const companyGuaranteeConstitutionDocuments = getDocumentsByType(
      documents,
      commonConsts.ORG_TYPE_CompanyLimitedGuarantee,
      commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules
    );
    allDocuments = allDocuments.concat(getDocuments(companyGuaranteeConstitutionDocuments));
  }

  if (organisationType === commonConsts.ORG_TYPE_CompanyLtdShares) {
    const companySharesCertRegDocuments = getDocumentsByType(
      documents,
      commonConsts.ORG_TYPE_CompanyLtdShares,
      commonConsts.DOC_UPLOAD_TYPE_CertificateRegistration
    );
    allDocuments = allDocuments.concat(getDocuments(companySharesCertRegDocuments));

    const companySharesStatementObjDocuments = getDocumentsByType(
      documents,
      commonConsts.ORG_TYPE_CompanyLtdShares,
      commonConsts.DOC_UPLOAD_TYPE_StatementObjects
    );
    allDocuments = allDocuments.concat(getDocuments(companySharesStatementObjDocuments));

    const companySharesConstitutionDocuments = getDocumentsByType(
      documents,
      commonConsts.ORG_TYPE_CompanyLtdShares,
      commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules
    );
    allDocuments = allDocuments.concat(getDocuments(companySharesConstitutionDocuments));
  }

  if (organisationType === commonConsts.ORG_TYPE_Other) {
    const otherCertificateDocuments = getDocumentsByType(
      documents,
      commonConsts.ORG_TYPE_Other,
      commonConsts.DOC_UPLOAD_TYPE_Certificate
    );
    allDocuments = allDocuments.concat(getDocuments(otherCertificateDocuments));

    const otherConstitutionDocuments = getDocumentsByType(
      documents,
      commonConsts.ORG_TYPE_Other,
      commonConsts.DOC_UPLOAD_TYPE_ConstitutionRules
    );
    allDocuments = allDocuments.concat(getDocuments(otherConstitutionDocuments));

    const otherStatementObjectDocuments = getDocumentsByType(
      documents,
      commonConsts.ORG_TYPE_Other,
      commonConsts.DOC_UPLOAD_TYPE_StatementObjects
    );
    allDocuments = allDocuments.concat(getDocuments(otherStatementObjectDocuments));
  }

  if (organisationType === commonConsts.ORG_TYPE_TrustDeed) {
    const trustDeedDocuments = getDocumentsByType(
      documents,
      commonConsts.ORG_TYPE_TrustDeed,
      commonConsts.DOC_UPLOAD_TYPE_TrustDeed
    );
    allDocuments = allDocuments.concat(getDocuments(trustDeedDocuments));

    const trustStatementObjectDocuments = getDocumentsByType(
      documents,
      commonConsts.ORG_TYPE_TrustDeed,
      commonConsts.DOC_UPLOAD_TYPE_StatementObjects
    );
    allDocuments = allDocuments.concat(getDocuments(trustStatementObjectDocuments));
  }

  const certificateNameChangeDocuments = getDocumentsByDocumentUploadType(
    documents,
    commonConsts.DOC_UPLOAD_TYPE_CertificateNameChange
  );

  allDocuments = allDocuments.concat(getDocuments(certificateNameChangeDocuments));

  return allDocuments;
};

export { getAllDocuments, getDocumentsByType, getDocuments };
